const _ = require('lib/underscore')

// country names that should have 'the' prepended
// when rendered alone (with no city or state)

// some of these are included even though
// google lists them correctly (or differently)
// to address possible outstanding freeform entries

// these must match how google renders them
const countries = [
    'United States',
    'United Kingdom',

    // this would technically get 'the',
    // but google returns 'Macedonia (FYROM)'
    'Former Yugoslav Republic of Macedonia',

    // these both include 'The' (capitalized)
    // as part of the official name
    // google is kindly adding that already
    'Bahamas',
    'Gambia',

    // google converts to 'Comoros'
    'Union of the Comoros',

    'Republic of the Congo',
    'Democratic Republic of the Congo',

    // google converts the latter to the former,
    // but still doesn't add 'the'
    'Marshall Islands',
    'Republic of the Marshall Islands',

    // google doesn't list
    'Kingdom of the Netherlands',
    'Republic of the Philippines',
    'Republic of the Sudan',

    'Netherlands',
    'Philippines',
    'Sudan',

    // google converts to 'Russia'
    'Russian Federation',

    'United Arab Emirates',
    'Maldives',
    'Seychelles',
    'Solomon Islands',

    // google converts to 'Czechia'
    'Czech Republic',

    'Dominican Republic',
]

function definitiveArticleCountry(country) {
    let massaged_country = country

    if (_.contains(countries, country)) {
        massaged_country = `the ${country}`
    }

    return massaged_country
}

module.exports = definitiveArticleCountry
